<ng-container [formGroup]="achForm">
    <div class="flex mb-2">
        <p-selectButton [options]="accountTypeOptions" formControlName="accountType"
            styleClass="delivery-option-select">
        </p-selectButton>
    </div>
    <div class="flex mb-2">
        <div class="flex flex-column gap-1">
            <span class="text-sm font-semibold"><app-translate key="NAME_ON_ACCOUNT"></app-translate> <span
                    class="text-red-500">*</span></span>
            <div class="flex ach-input-width">
                <input pInputText class="skinny w-full" formControlName="acctHolderName"
                    (keypress)="onlyAlphabets($event)" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ACCOUNT_HOLDER_NAME')]"
                [control]="achForm.controls['acctHolderName']"></sp-control-error>
        </div>
    </div>

    <div class="flex mb-2">
        <div class="flex flex-column gap-1">
            <span class="text-sm font-semibold"><app-translate key="ROUTING_NUMBER"></app-translate> <span
                    class="text-red-500">*</span></span>
            <div class="ach-input-width">
                <p-password formControlName="routingNumber" autocomplete="routingNumber" [feedback]="false"
                    class="w-full" styleClass="skinny w-full" (keypress)="onlyNumbers($event)" [toggleMask]="true"
                    [maxLength]="9" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ROUTING_NUMBER')]"
                [control]="achForm.controls['routingNumber']"></sp-control-error>
        </div>
    </div>

    <div class="flex mb-2">
        <div class="flex flex-column gap-1">
            <span class="text-sm font-semibold"><app-translate key="ACCOUNT_NUMBER"></app-translate> <span
                    class="text-red-500">*</span></span>
            <div class="ach-input-width">
                <p-password formControlName="acctNumber" autocomplete="acctNumber" [feedback]="false" class="w-full"
                    styleClass="skinny w-full" (keypress)="onlyNumbers($event)" [toggleMask]="true" [maxLength]="17" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ACCOUNT_NUMBER')]"
                [control]="achForm.controls['acctNumber']"></sp-control-error>
        </div>
    </div>

    <div class="flex mb-2">
        <div class="flex flex-column gap-1">
            <span class="text-sm font-semibold"><app-translate key="CONFIRM_ACCOUNT_NUMBER"></app-translate> <span
                    class="text-red-500">*</span></span>
            <div class="ach-input-width">
                <p-password formControlName="confirmAcctNumber" autocomplete="confirmAcctNumber" [feedback]="false"
                    class="w-full" styleClass="skinny w-full" (keypress)="onlyNumbers($event)" [toggleMask]="true"
                    [maxLength]="17" />
            </div>
            <sp-control-error [parameters]="[languageService.getTranslation('ACCOUNT_NUMBER')]"
                [control]="achForm.controls['confirmAcctNumber']"></sp-control-error>
             @if (achForm?.controls['confirmAcctNumber']?.touched && achForm?.errors?.['sameAcctNumber']) {
                <small class="p-error">Account numbers must match</small>
            }
        </div>
    </div>
</ng-container>